import React from "react";
import {Navigate} from "react-router-dom";

const nextPage = "/do_you_take";

class Cancer extends React.Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.setCancer = this.setCancer.bind(this);
        this.state = {
            redirect: false,
        }
    }
    setCancer(e) {
        this.props.onDataChange(e, 'cancer');
        setTimeout(function() {this.nextPage()}.bind(this), 400);
    }
    nextPage () {
        this.setState({redirect: true,})
    }
    componentDidMount() {
        this.props.onDataChange('cancer', 'page');
    }

    render() {
        return (
            <div className={'text-center page pageCancer'}>
                <h1>Have you ever been<br /> diagnosed with cancer?</h1>
                <div className={'row'}>
                    <div className={'col'}>
                        <button type="button" className={'btn-choice btn-choice-big ' + (this.props.cancer === 'Yes'  ? 'active' : '')} onClick={() => this.setCancer('Yes')}>Yes</button>
                    </div>
                </div><br />
                <div className={'row'}>
                    <div className={'col'}>
                        <button type="button" className={'btn-choice btn-choice-big ' + (this.props.cancer === 'No'  ? 'active' : '')} onClick={() => this.setCancer('No')}>No</button>
                    </div>
                </div>
                {this.state.redirect && (
                    <Navigate to={nextPage} replace={true} />
                )}
            </div>
        )
    }
}

export default Cancer;
